import { Box, Breadcrumbs, Button, Grid, Link, Typography } from "@mui/material";
import { changeModalValue } from "../../store/slices/function/feedback";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { useLazyGetExportCompaniesQuery } from "../../store/api/backoffice/backofficeApi";

function BackOfficeHeader() {
    const dispatch = useDispatch<AppDispatch>()
    const [getExportCompanies] = useLazyGetExportCompaniesQuery()

    const handleCSVData = async () => {
        const { data: csvData } = await getExportCompanies()
        if (csvData) {
            let downloadLink = document.createElement("a");
            let blob = new Blob(["\ufeff", csvData]);
            let url = URL.createObjectURL(blob);
            downloadLink.href = url;
            downloadLink.download = `empresas-grup-barraqueiro-${Date.now()}.csv`;
        
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: 'grey.100', padding: '0.5rem', paddingBlockEnd: '0.1rem'}} >
        <Grid container direction='row' xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                    <Typography></Typography>
                </Link>
                <Link underline="hover" color="inherit" href="/">
                    <Typography>...</Typography>
                </Link>
                    <Typography color="text.primary">Empresas</Typography>
            </Breadcrumbs>
        </Grid>
        <Grid container direction='row' spacing={2} xs={12}>
            <Grid item xs={4}>
                <Typography sx={{paddingBlock: '0.4rem'}} variant="h4">Empresas</Typography>
            </Grid>
            <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'row', justifyContent:'flex-end'}}>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginInline: '1rem'}}>
                    <Button onClick={handleCSVData}>Exportar Empresas</Button>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginInline: '1rem'}}>
                    <Button sx={{paddingBlock: '0.5rem'}} onClick={() => dispatch(changeModalValue({ open: true }))} variant="contained">Adicionar empresa</Button>
                </Box>
            </Grid>
        </Grid>
    </Box>
  );
}

export default BackOfficeHeader;